import { action,makeObservable } from 'mobx';
import { SiteStore } from './store';
import { readForum, readPluginList, readEmoji } from '@server';

export class SiteAction extends SiteStore {
    constructor(props) {
        super(props);
        makeObservable(this);
    }

    @action
    async fetchSiteConfig(ctx = null) {
        this.isLoading = true;
        try {
            const res = await readForum({}, ctx);
            if (res.code === 0) {
                this.siteConfig = res.data;
            } else if (res.code === -3005) {
                this.closeSiteConfig = res.data;
            }
            return res;
        } catch (error) {
            this.error = error.message;
            throw error;
        } finally {
            this.isLoading = false;
        }
    }

    @action
    async fetchPluginConfig(ctx = null) {
        try {
            const res = await readPluginList({}, ctx);
            if (res.code === 0) {
                this.pluginConfig = res.data;
            }
            return res;
        } catch (error) {
            this.error = error.message;
            throw error;
        }
    }

    @action
    setSiteConfig(config) {
        this.siteConfig = config;
    }

    
    

    @action
    setCloseSiteConfig(config) {
        this.closeSiteConfig = config;
    }

    @action
    setPluginConfig(config) {
        this.pluginConfig = config;
    }

    @action
    setLoading(loading) {
        this.isLoading = loading;
    }

    @action
    setError(error) {
        this.error = error;
    }

    // 表情相关
    @action
    async fetchEmoji(ctx = null) {
        this.isEmojiLoading = true;
        try {
            const res = await readEmoji({}, ctx);
            if (res.code === 0 && res.data) {
                this.emojiList = res.data;
            }
            return res;
        } catch (error) {
            this.error = error.message;
            throw error;
        } finally {
            this.isEmojiLoading = false;
        }
    }

    @action
    setShowHeader(show) {
        this.showHeader = show;
    }

    @action
    getShowHeader() {
        return this.showHeader;
    }
    @action
    setAppDownloadShowStatus(appDownloadShowStatus) {
        console.log('关闭');
        this.appDownloadShowStatus = appDownloadShowStatus;
    }

    @action
    getAppDownloadShowStatus() {
        return this.appDownloadShowStatus;
    }

    @action
    setCurrentPhotographyWorkId(id) {
        this.currentPhotographyWorkId = id || null;
    }
}

const siteAction = new SiteAction();
export default siteAction;